import icon from './ВКО_Зайсанский_район,_Тарбагатайский_район.svg'

export default [
  icon
]
